import React from 'react';

import {Card} from '../../../components/Card/Card';

import cls from './HowToUse.module.scss'

export const HowToUse = () => (
    <div className={cls.block}>
        <h2>Как воспользоваться</h2>
        <div className={cls.cards}>
            <Card bottom={
                    <div>Подключите услугу и&nbsp;получите сертификат на&nbsp;электронную почту
                    </div>
            }><h2>Шаг&nbsp;1</h2></Card>
            <Card bottom={
                    <div>Получите консультацию юриста, заполнив заявку на&nbsp;сайте<br/>
                        <a href={'https://fintechservice.group/consultation'} target={'_blank'} rel={'noreferrer'}>https://fintechservice.group/consultation</a>
                    </div>
            }><h2>Шаг&nbsp;2</h2></Card>
            <Card bottom={
                    <div>Онлайн сопровождение в&nbsp;процессе взаимодействия с&nbsp;полицией по&nbsp;вопросам кражи денежных средств с&nbsp;карты или незаконного оформления кредита третьими лицами
                    </div>
            }><h2>Шаг&nbsp;3</h2></Card>
        </div>
    </div>
)